import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../cfet-core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-utf-landing',
    templateUrl: './utf-landing.component.html',
    styleUrls: ['./utf-landing.component.scss'],
    standalone: false
})
export class UtfLandingComponent extends CfetBaseComponent implements OnInit {
  showLoading = false;

  constructor(private cfetService: CfetService,  private router: Router,
    private title: Title) {
    super();
  }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.landing.htmlTitle);
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      sessionStorage.removeItem('orgInfo');
    }
    if (sessionStorage.getItem('orgDetailInfo') && Object.keys(sessionStorage.getItem('orgDetailInfo')).length !== 0) {
      sessionStorage.removeItem('orgDetailInfo');
    }
    sessionStorage.clear();
    this.cfetService.isLandingPage.next(true);
  }

checkEligibility(event) {
  if (event.type === 'Enter' || event.type === 'click' || event.keyCode === 13) {
    this.redirecturl(this.cfetNavLinks.utf_header_links.check_eligibility_link);
  }
}
  redirecturl(url) {
    window.location.href = url;
  }

}